import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getCurrencies = createAsyncThunk(
    "Currency/get",
    async (payload = {}, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setActivePayload(payload));
            const filteredPayload = Object.fromEntries(
                Object.entries(payload || {}).filter(
                    ([, value]) => value !== null && value !== undefined && value !== ""
                )
            );
            const params = new URLSearchParams();

            for (const [key, value] of Object.entries(filteredPayload)) {
                if (Array.isArray(value)) {
                    value.forEach((item) => {
                        params.append(key, item);
                    });
                } else {
                    params.append(key, value);
                }
            }
            const queryString = params.toString();
            const url = queryString ? `${API_URL.CURRENCY.SLUG}?${queryString}` : API_URL.CURRENCY.SLUG;

            const { data } = await axios.get(url);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.data || error.message);
        }
    }
);

// Lookup variant — hits the permission-free /lookup endpoint. Used by dropdowns
// on screens of other modules; the management list keeps using getCurrencies.
export const getCurrenciesLookup = createAsyncThunk(
    "Currency/getLookup",
    async (payload = {}, { rejectWithValue }) => {
        try {
            const filteredPayload = Object.fromEntries(
                Object.entries(payload || {}).filter(
                    ([, value]) => value !== null && value !== undefined && value !== ""
                )
            );
            const params = new URLSearchParams();

            for (const [key, value] of Object.entries(filteredPayload)) {
                if (Array.isArray(value)) {
                    value.forEach((item) => {
                        params.append(key, item);
                    });
                } else {
                    params.append(key, value);
                }
            }
            const queryString = params.toString();
            const url = queryString ? `${API_URL.CURRENCY.LOOKUP}?${queryString}` : API_URL.CURRENCY.LOOKUP;

            const { data } = await axios.get(url);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.data || error.message);
        }
    }
);

export const createCurrency = createAsyncThunk(
    "Currency/create",
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axios.post(`${API_URL.CURRENCY.SLUG}`, payload);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.data);
        }
    }
);

export const editCurrency = createAsyncThunk(
    "Currency/put",
    async (payload, { rejectWithValue }) => {
      try {
        const { data } = await axios.put(`${API_URL.CURRENCY.SLUG}`, payload);
        return data.data;
      } catch (error) {
        return rejectWithValue(error.data);
      }
    }
  );

  export const deleteCurrency = createAsyncThunk(
    "Currency/delete",
    async (payload, { rejectWithValue }) => {
      try {
        const { data } = await axios.delete(`${API_URL.CURRENCY.SLUG}/${payload}`);
        return data.data;
      } catch (error) {
        return rejectWithValue(error.data);
      }
    }
  );

const currencySlice = createSlice({
    name: "currency",
    initialState: {
        currency_list: [],
        current_values: null,
        active_payload: null,
    },
    reducers: {
        setCurrentValues(state, action) {
            state.current_values = action.payload;
        },
        setActivePayload(state, action) {
            state.active_payload = action.payload;
        },
        resetCurrentValue(state) {
            state.current_values = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getCurrencies.fulfilled, (state, action) => {
            state.currency_list = action.payload.data.list;
        });
        builder.addCase(getCurrenciesLookup.fulfilled, (state, action) => {
            state.currency_list = action.payload.data.list;
        });
    }
})

export const { setCurrentValues, setActivePayload, resetCurrentValue } = currencySlice.actions;
export default currencySlice.reducer;
